/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S7_P2Inputs */

const en_guide_json_syntax_errors_s7_p2 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two more issues catch most of the rest. Comments are not allowed in standard JSON, so a helpful note pasted from code will break the parse. And special characters inside strings, such as a literal newline or an unescaped backslash, need to be escaped. A formatter that validates as it goes will point at the exact line, which is faster than reading the whole file.`)
};

const ko_guide_json_syntax_errors_s7_p2 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 가지가 나머지 대부분을 잡아냅니다. 표준 JSON에는 주석이 허용되지 않으므로 코드에서 복사한 설명이 파싱을 깨뜨립니다. 또 문자열 안의 특수 문자, 예를 들어 리터럴 줄바꿈이나 이스케이프하지 않은 백슬래시는 이스케이프해야 합니다. 입력하는 대로 검증하는 포맷터는 정확한 줄을 짚어 주므로 파일 전체를 읽는 것보다 빠릅니다.`)
};

const ja_guide_json_syntax_errors_s7_p2 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あと二つが残りの大半を捉えます。標準 JSON ではコメントが許されないため、コードから貼り付けた説明がパースを壊します。また文字列内の特殊文字、たとえばそのままの改行やエスケープしていないバックスラッシュはエスケープが必要です。入力しながら検証するフォーマッターは正確な行を指してくれるので、ファイル全体を読むより速いです。`)
};

/**
* | output |
* | --- |
* | "Two more issues catch most of the rest. Comments are not allowed in standard JSON, so a helpful note pasted from code will break the parse. And special chara..." |
*
* @param {Guide_Json_Syntax_Errors_S7_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s7_p2 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S7_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S7_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s7_p2(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s7_p2(inputs)
	return ja_guide_json_syntax_errors_s7_p2(inputs)
});